import { Component } from '@angular/core';

@Component({
  selector: 'app-account-centre-promo-card',
  standalone: true,
  imports: [],
  templateUrl: './account-centre-promo-card.component.html',
  styleUrl: './account-centre-promo-card.component.scss'
})
export class AccountCentrePromoCardComponent {

}
